import { render, staticRenderFns } from "./ProjectInitialized.vue?vue&type=template&id=0ce85f45&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce85f45')) {
      api.createRecord('0ce85f45', component.options)
    } else {
      api.reload('0ce85f45', component.options)
    }
    module.hot.accept("./ProjectInitialized.vue?vue&type=template&id=0ce85f45&", function () {
      api.rerender('0ce85f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Research/ProjectInitialized.vue"
export default component.exports